import AuthenticationService from './AuthenticationService'
import Store from '../store/Store'
import axios from '../lib/axios'
import CognitoService from './CognitoService'
import Bugsnag from './Bugsnag'
const url = process.env.ZLICK_V2

export default {
  async createUserAndAddToGroup (email, name, roles) {
    if (!AuthenticationService.isInRole(['admin'])) throw new Error('Permission denied. Cannot Access users')
    var groupName = Store.getters.getActiveCognitoGroup
    try {
      var response = await axios.get(url + '/addUser', {
        params: {
          Username: email,
          name: name,
          groupName: groupName,
          roles: roles.join(',')
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'zlick-group': Store.getters.getActiveCognitoGroup
        }
      })
        .catch((error) => {
          throw new Error('Failed to create Users ' + error)
        })

      // If user was successfully created, try to add them to metabase group if enabled
      if (response) {
        await this.addUserToMetabaseGroupIfEnabled(response.data.metabaseId, groupName)
      }

      return response
    } catch (err) {
      if (err.name === 'UsernameExistsException') {
        console.warn('User account already exists, skipping to next step')
        throw new Error('User account already exists')
      } else {
        throw new Error('Failed to create Users ' + err)
      }
    }
  },

  async addUserToMetabaseGroupIfEnabled (metabaseId, groupName) {
    if (!metabaseId || metabaseId === 'undefined' || metabaseId === 'null') {
      console.log('No metabase id found, skipping to next step')
      return
    }

    try {
      await CognitoService.addUserToMetabaseGroup(metabaseId, groupName)
      console.log('User added to Metabase')
    } catch (metabaseError) {
      console.warn('Failed to add user to Metabase group:', metabaseError)
      Bugsnag.send(metabaseError)
      // Don't throw error - this should not break the main user creation flow
    }
  },

  async updateRoles (email, roles) {
    if (!AuthenticationService.isInRole(['admin'])) throw new Error('Permission denied. Cannot Access users')
    try {
      var response = axios.get(url + '/updateUser', {
        params: {
          Username: email,
          roles: roles.join(',')
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'zlick-group': Store.getters.getActiveCognitoGroup
        }
      })
        .catch((error) => {
          throw new Error('Failed to update UserRoles ' + error)
        })
      return response
    } catch (err) {
      throw new Error('Failed to update UserRoles ' + err)
    }
  },
  async updateOtpAndOtpTime (email, pinCode, pincodeTime, pincodeUsageCount) {
    try {
      var response = axios.get(url + '/updateUser', {
        params: {
          Username: email,
          pinCode: pinCode,
          pincodeTime: pincodeTime,
          pincodeUsageCount: pincodeUsageCount

        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'zlick-group': Store.getters.getActiveCognitoGroup
        }
      })
        .catch((error) => {
          throw new Error('Failed to update updateOtpAndOtpTime ' + error)
        })
      return response
    } catch (err) {
      throw new Error('Failed to update updateOtpAndOtpTime  ' + err)
    }
  },

  getAllUsersInGroup: async () => {
    if (!AuthenticationService.isInRole(['admin'])) throw new Error('Permission denied. Cannot Access users')
    var groupName = Store.getters.getActiveCognitoGroup
    try {
      var response = axios.get(url + '/listUsers', {
        params: {
          GroupName: groupName,
          Limit: 60
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'zlick-group': Store.getters.getActiveCognitoGroup
        }
      })
        .catch((error) => {
          throw new Error('Failed to fetch all users' + error)
        })
      return response
    } catch (error) {
      throw new Error('Failed to fetch all users' + error)
    }
  },

  deleteUserInGroup: async (name) => {
    if (!AuthenticationService.isInRole(['admin'])) throw new Error('Permission denied. Cannot Access users')
    try {
      var response = axios.get(url + '/deleteUser', {
        params: {
          Username: name
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'zlick-group': Store.getters.getActiveCognitoGroup
        }
      })
        .catch((error) => {
          throw new Error('Failed to delete' + error)
        })
      return response
    } catch (error) {
      throw new Error('Failed to delete user ' + error)
    }
  },

  updateApiClientTwoFA: async (portalTwoFAEnabled) => {
    try {
      var abc = JSON.parse(localStorage.getItem('apiClient'))
      var response = axios.get(url + '/updateApiClient', {
        params: {
          id: abc._id,
          portalTwoFAEnabled: portalTwoFAEnabled
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
          'zlick-group': Store.getters.getActiveCognitoGroup
        }
      })
        .catch((error) => {
          throw new Error('Failed to update ApiClient ' + error)
        })
      return response
    } catch (err) {
      throw new Error('Failed to update ApiClient ' + err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/UserManagementService.js